import { createSlice } from "@reduxjs/toolkit";
import { Toastify } from "../../../../components/Toaster";
import { addingSideEffects, errorSideEffects, loadingSideEffects, successSideEffects, updatingSideEffects } from "../..";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface PushNotification {
  IsEnabled?: boolean;
  Message?: string;
  QRCodeWidth?: number;
  NotificationService?: string;
  CustomAppName?: string;
  AWSsettings: {
    AccessKeyId?: string;
    SecretAccessKey?: string;
    Region?: string;
  };
  AndroidSettings: {
    Enabled: false;
    PlaystoreUrl?: string;
    IsServiceJsonPresent?: boolean;
    PlatformARN?: string;
    ServiceJson?: string;
  };
  IOSsettings: {
    Enabled?: boolean;
    AppstoreUrl?: string;
    BundleId?: string;
    IsApnsCertPresent?: boolean;
    Environment?: string;
    PlatformARN?: string;
    ApnsCertificate?: string;
  };
  errorCode?: string;
  description?: string;
}

export interface PushNotificationState {
  Data: PushNotification;
  isLoading: boolean;
  isUpdating: boolean;
  isSuccess: boolean;
  isAdding: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const PushNotificationSlice = createSlice({
  name: "pushNotify",
  initialState: {
    Data: {},
    isLoading: false,
    isUpdating: false,
    isAdding: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
  },
  reducers: {
    getPushNotification(state) {
      Object.assign(state, loadingSideEffects);
    },
    getPushNotificationSuccess(state, action) {
      state.Data = action.payload;
      Object.assign(state, successSideEffects);
    },
    getPushNotificationError(state, action) {
      Object.assign(state, errorSideEffects);
      state.errorMessage = action.payload;
    },
    updatePushNotification(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updatePushNotificationSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "success"));
      state.Data = action.payload;
      Toastify("success", "Push Notification updated successfully");
    },
    updatePushNotificationError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    },
    addPushNotification(state, action) {
      Object.assign(state, addingSideEffects, getRequestTrackingState(action));
    },
    addPushNotificationSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "success"));
      state.Data = action.payload;
      Toastify("success", "Push Notification added successfully");
    },
    addPushNotificationError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const {
  getPushNotification,
  getPushNotificationError,
  getPushNotificationSuccess,
  updatePushNotification,
  updatePushNotificationError,
  updatePushNotificationSuccess,
  addPushNotification,
  addPushNotificationError,
  addPushNotificationSuccess
} = PushNotificationSlice.actions;

export default PushNotificationSlice.reducer;
